export const SALEOR_GRAPHQL_URL = "https://demo.saleor.io/graphql/";
export const SALEOR_STOREFRONT_URL = "https://demo.saleor.io/";
